<template>
      <vs-card>
        
          <div>
            <!-- {{subject_ids}} -->
          <!-- <pre>{{lessonLists}}</pre> -->   
            <vs-table
              multiple
              v-model="selected"
              :data="lessonLists"
            >
              <template slot="header">
                <h3>Lessons List</h3>
                <!-- <pre>{{courseLists}}</pre> -->
              </template>
              <template slot="thead">
                <vs-th> Name </vs-th>
                <vs-th> Description </vs-th>
                <vs-th> Subject </vs-th>
                <vs-th> No of Topics </vs-th>
                <vs-th> No of Files </vs-th>
                <vs-th> Tags </vs-th>
              
              </template>

              <template slot-scope="{ data }">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td >
                    {{ data[indextr].name }}
                  </vs-td>
                    <vs-td >
                    {{ data[indextr].description }}
                  </vs-td>
                
                  <vs-td>
                    <span v-for="(subject,index) in data[indextr].subjects" :key="index">
                                {{subject.subject.subject_name}}
                    <span v-if="index+1 < data[indextr].subjects.length">, </span>
                    </span> 
                  </vs-td >
                 
                        <vs-td >
                    {{data[indextr].lessonTopics.length}}
                  </vs-td>

                   <vs-td >
                    {{data[indextr].lessonFiles.length}}
                  </vs-td>
                  
                  <vs-td>
                      <span v-for="(tag,tagindex) in data[indextr].lessonTags" :key="tagindex">
                                {{tag.tag.name}}
                      <span v-if="tagindex+1 < data[indextr].lessonTags.length">, </span>
                    </span> 
                   </vs-td>
                 
                 
                </vs-tr>
              </template>
            </vs-table>
              <vs-button v-if="query_page.has_next" @click="loadMoreData" style="float:right">Load More Data</vs-button>
             <vs-button class="my-4" @click="exportAssignmentList">Export to Course Builder</vs-button>
          </div>
     
        </vs-card>
</template>
<script>
import vSelect from 'vue-select'
import {lessonListing} from '@/api/course-builderapi'
import {mapGetters} from 'vuex'
export default {
  components: {
    vSelect
  },
  data () {
    return {
      selected:[],
      lessonLists:[],
      query_page:{
        'total': '',
        'limit': 10,
        'has_next': false,
        'current_page': 1,
        'next_page_url': null,
        'previous_page_url': ''
      }
    }
  },
  computed:{
    ...mapGetters(
      ['get_homework_subject_id']
    ),
    selectedLength () {
      if (this.selected.length > 1) {
        return true
      }
    }
  },
  mounted () {
    
    this.fetchLessonList()
  },
  props:{
    subject_ids:{
      type:Array,
      required:true,
      default:() => []
    }
  },
  methods:{
    filterBySubject (subject_ids) {
      this.tagSearch = []
      this.subject_ids = subject_ids
      this.fetchLessonList()
      
    },
    tagSearchWise () {
      this.subject_ids = false
      this.fetchLessonList()

    },
    async fetchLessonList () {
      try {
        this.$vs.loading({
          text:'Fetching Lesson please wait ...'
        })
        let payload = {}
        if (this.subject_ids) {
          payload = {
            subject_ids:this.subject_ids
          }
          

        }
        const customer_id = this.$store.getters.customerId
        const responeList = await lessonListing(customer_id, payload)
        this.lessonLists =  responeList.data.data.lessonlist
        
      } catch (error) {
        
      } finally {
        this.$vs.loading.close()
      }

    },
    loadMore () {
      this.loadMoreData()
        
    },
    async loadMoreData () {
      try {
        this.$vs.loading({
          text:'Fetching Lesson please wait ...'
        })
        let payload = {}
        if (this.subject_ids) {
          payload = {
            subject_ids:this.subject_ids
          }
          

        }
        const customer_id = this.$store.getters.customerId
        const responeList = await lessonListing(customer_id, payload, this.query_page.current_page + 1)
        this.lessonLists =  responeList.data.data.lessonlist
        
        this.query_page = responeList.data.meta

      } catch (error) {
        
      } finally {
        this.$vs.loading.close()
      }


    // 

    },
    exportAssignmentList () {
      if (this.selected.length) {
        const obj = this.selected
        this.$emit('getLessonLists', obj)
      }

    }
  }
}
</script>